export default "__VITE_ASSET__BBQyyJ7z__"